import { useState } from "react";
import app from '../../firebase';

import {
    getFirestore,
    updateDoc,
    doc,
    arrayUnion
} from 'firebase/firestore';

export default function Bubbles({ data }) {
    
    const [newMessage, setNewMessage] = useState();
    
    const sendMessage = () => {
        updateDoc(doc(getFirestore(app), 'conversations', data.conversation), {
            messages: arrayUnion({
                message: newMessage,
                datetime: new Date(),
                sender: {
                    id: data.profile[0],
                    name: data.profile[1].name
                },
                receiver: {
                    id: data.seller.id,
                    name: data.seller.name
                }
            })
        });

    }

    return(
        <>
            <textarea
                rows="2"
                className="form-control mb-2"
                style={{ resize: 'none' }}
                onChange={data => setNewMessage(data.target.value)}
            ></textarea>
            
            <button
                className="btn btn-dark w-100"
                onClick={sendMessage}
                disabled={
                    data.messages ? false : true
                }
            >
                <i className="bi-send me-1"></i>
                Send Message
            </button>
        </>
    )
}